import React from 'react';
import { Link } from '@material-ui/core';
import { Col, Container, Row } from 'react-bootstrap';
const Footer = () => (

    <div className="main-footer text-center">
        <Container>
            <Row className="row-sm">
                <Col md={8} className="col-md-8 mobile-text-right">
                <span>Copyright © {new Date().getFullYear()} <a className='text-danger' href='https://amyfintech.com' target="_blank">AMY Fintech Software</a>. All rights reserved.</span>

                    {/* <span>Copyright ©  {new Date().getFullYear()} <a className='text-danger' href="https://globalfinservice.in" target='_blank'>Global Finance Services</a>. All rights reserved.</span> */}
                </Col>
                <Col md={4} className="col-md-4 mobile-text-right">
                    <span>Powered by <Link className='dark-primary font-weight-bold' href="https://amytechnologies.in/" target="_blank">AMY Technologies</Link> </span>
                </Col>
            </Row>
        </Container>
    </div>
);

Footer.propTypes = {};

Footer.defaultProps = {};

export default Footer;
